export default __webpack_public_path__ + "static/media/190629_190332_IMG_2591.4280ad34.jpg";